import React from "react";

interface ChatFloatButtonProps {
  onClick: () => void;
  isOpen?: boolean;
  className?: string;
}

const ChatFloatButton: React.FC<ChatFloatButtonProps> = ({
  onClick,
  isOpen = false,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`fixed bottom-4 right-4 w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg z-30 transition-all duration-200 ${
        isOpen ? "transform rotate-45" : ""
      } ${className}`}
    >
      <span className="text-lg">💬</span>
    </button>
  );
};

export default ChatFloatButton;